import { locale } from './../../ModuleEditor/util/locale-wrapper';

const SHOW_FIELDS_TO = {
  NEW_ENTRANTS:   'entry.new',
  KNOWN_ENTRANTS: 'entry.existing',
  EVERYONE:       'entry.all',
};

const SHOW_FIELDS_TO_ALL = _.values(SHOW_FIELDS_TO);

const SHOW_FIELDS_TO_LIST = [
  { text: locale('New entrants'), value: SHOW_FIELDS_TO.NEW_ENTRANTS },
  { text: locale('Known entrants'), value: SHOW_FIELDS_TO.KNOWN_ENTRANTS },
  { text: locale('Everyone'), value: SHOW_FIELDS_TO.EVERYONE },
];

export { SHOW_FIELDS_TO, SHOW_FIELDS_TO_LIST, SHOW_FIELDS_TO_ALL };

export default SHOW_FIELDS_TO;
